export default [
  
  { header: 'Configuration' },
  {
    title: 'Admin Users',
    route: 'admin-users-page',
    icon: 'UsersIcon',
  },
  {
    title: 'Settings',
    route: 'settings-page',
    icon: 'SettingsIcon',
  },
]
